module.exports = __webpack_public_path__ + "media/images/flags/nf-ce4527ffebfa10264a74c6864a10e4a9.svg";